import { type DirectoriesWithIconsBySearch } from './misc'

export const getFilteredIcons = (
	directoriesWithIcons: DirectoriesWithIconsBySearch,
	query: string,
) => {
	// TODO: would kent's matche be faster while achieving the same result?
	const trimmedQuery = query.trim().toLowerCase()

	// return early to avoid unnecessary filtering
	if (trimmedQuery.length === 0) {
		return directoriesWithIcons
	}

	// Split query into individual words
	const queryWords = trimmedQuery.split(/[-\s]+/)

	const filteredDirectoriesWithIcons = directoriesWithIcons
		.map((directory) => {
			return {
				...directory,
				icons: directory.icons.filter((icon) => {
					// Split by hyphens and spaces to get individual words
					const iconWords = icon.name.split(/[-\s]+/)

					// Check if all query words are found in the icon name
					return queryWords.every((queryWord) =>
						iconWords.some((iconWord) => iconWord.startsWith(queryWord)),
					)
				}),
			}
		})
		.filter((directory) => directory.icons.length > 0)

	return filteredDirectoriesWithIcons
}
